import React, { useEffect, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Box, Flex } from '@goodrx/matisse-react';
import { ComponentRenderer } from '@goodrx/x-core';
import { DESKTOP_BREAKPOINTS, useBreakpoint } from '../../../../utils/react/useBreakpoint';
const StyledComponentRenderer = styled(ComponentRenderer)`
  flex-grow: 1;
  height: 100%;
`;
export const Vertical = ({
  componentMap,
  className,
  tabletContentCollection,
  mobileContentCollection
}) => {
  const theme = React.useContext(ThemeContext);
  const [showMobileItems, setShowMobileItems] = useState(false);
  const breakpoint = useBreakpoint();
  useEffect(() => {
    setShowMobileItems(!DESKTOP_BREAKPOINTS.includes(breakpoint));
  }, [breakpoint]);
  const items = !showMobileItems || !(mobileContentCollection !== null && mobileContentCollection !== void 0 && mobileContentCollection.items.length) ? (tabletContentCollection === null || tabletContentCollection === void 0 ? void 0 : tabletContentCollection.items.filter(item => !!item)) || [] : mobileContentCollection === null || mobileContentCollection === void 0 ? void 0 : mobileContentCollection.items.filter(item => !!item);
  const width = `${100 / items.length}%`;
  return /*#__PURE__*/React.createElement(Flex, {
    className: className,
    flexDirection: {
      _: 'column',
      md: 'row'
    },
    alignContent: "stretch"
  }, items.map((data, i) => /*#__PURE__*/React.createElement(Box, {
    key: data.sys.id,
    width: {
      _: '100%',
      md: width
    },
    pr: {
      _: 0,
      md: i !== items.length - 1 ? theme.xSpace[2] : 0
    },
    pl: {
      _: 0,
      md: i > 0 ? theme.xSpace[2] : 0
    },
    pt: {
      _: 0
    },
    pb: {
      _: 0
    }
  }, /*#__PURE__*/React.createElement(StyledComponentRenderer, {
    data: data,
    componentMap: componentMap,
    key: data.sys.id
  }))));
};